<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Seleccionar Bodega</p>
    </header>
    <div class="modal-card-body">
      <div class="columns">
        <div
          v-for="columna in columnas"
          :key="`columna-${columna}`"
          class="column"
        >
          <div
            v-for="(item, index) in itemsPorColumna(columna)"
            :key="`item-${columna}-${index}`"
            class="card"
            @click="seleccionarBodega(item)"
          >
            <div class="card-content">
              <p class="title is-4">
                {{ item.sucursal.nombre }}
              </p>
              <p class="subtitle is-6">
                {{ item.nombre }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer class="modal-card-foot">
      <button class="button" type="button" @click="cerrarAsignacionHandle">
        Cerrar
      </button>
    </footer>
    <b-loading
      :is-full-page="false"
      :can-cancel="false"
      :active.sync="estaCargando"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'SeleccionBodega',
  data() {
    return {
      estaCargando: true,
      columnas: 1
    }
  },
  computed: {
    ...mapState('sesion', ['sesion', 'bodega'])
  },
  mounted() {
    this.estaCargando = false
  },
  methods: {
    cerrarAsignacionHandle() {
      this.$emit('cancelar')
    },
    seleccionarBodega(bodega) {
      const self = this
      if (bodega.id === this.bodega.id) this.$emit('cancelar')
      self.$store
        .dispatch('sesion/getSesion', {
          nombreUsuario: this.sesion.nombreUsuario,
          bodega: bodega.id
        })
        .then(() => self.$emit('cancelar'))
        .catch((err) => this.procesarError(err))
    },
    itemsPorColumna(columna) {
      const chunk = Math.ceil(this.sesion.bodegas.length / this.columnas)
      const first = columna * chunk - chunk
      const last = columna * chunk
      return this.sesion.bodegas.slice(first, last)
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  margin-bottom: 5px;
  &:hover {
    background-color: hsla(204, 86%, 53%, 0.8);
  }
  .card-content {
    padding: 0.5rem 1rem;
    .columns {
      margin-bottom: 0px;
      .column {
        padding: 0.5rem;
      }
    }
  }
}
</style>
